import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/posts/posts.js");
